<template>
  <div class="calculator-page">
    <header class="calculator-header">
      <h1>Калькулятор цепей</h1>
      <p>Расчет ширины цепи по ее весу и длине</p>
    </header>
    <section class="calculator-section">
      <div>
        <select id="chain-type-select" v-model="chainType">
          <option
            v-for="key in Object.keys(chainTypes)"
            v-bind:key="key"
            v-bind:value="key"
            v-bind:selected="key === chainType"
          >{{ chainTypes[key] }}</option>
        </select>
      </div>
    </section>
    <section class="calculator-section">
      <div class="inline-input-wrapper">
        <label for="weight" class="gr">Вес</label>
        <input type="number" name="weight" v-model.number="weight">
      </div>
      <div class="inline-input-wrapper">
        <label for="length" class="cm">Длина</label>
        <input type="number" name="length" v-model.number="length">
      </div>
    </section>
    <section class="calculator-section">
      <table>
        <tr>
          <td>Диаметр проволоки</td>
          <td>{{ wireDiameter | numberFormat }} мм</td>
        </tr>
        <tr>
          <td>Диаметр ригеля</td>
          <td>{{ rigelDiameter | numberFormat }} мм</td>
        </tr>
        <tr>
          <td>Ширина</td>
          <td>{{ width | numberFormat }} мм</td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
import utils from './utils'

export default {
  name: 'ChainsCalculatorPage',
  data () {
    return {
      chainType: 'bismarkSmall',
      chainTypes: {
        'bismarkSmall': 'Цепь "Бисмарк" (мелкий)',
        'bismarkBig': 'Цепь "Бисмарк" (крупный)',
        'kaiser': 'Цепь "Кайзер"'
      },
      weight: 10,
      length: 55,
      weightCoeffs: {
        'bismarkSmall': 3,
        'bismarkBig': 3,
        'kaiser': 2
      },
      lengthCoeffs: {
        'bismarkSmall': 2.4,
        'bismarkBig': 2.4,
        'kaiser': 3
      },
      wireDiameterCoeffs: {
        'bismarkSmall': 3.8,
        'bismarkBig': 3.35,
        'kaiser': 5.13
      },
      rigelDiameterCoeffs: {
        'bismarkSmall': 1.93,
        'bismarkBig': 1.93,
        'kaiser': 2
      }
    }
  },
  computed: {
    wireDiameter: function () {
      return Math.sqrt(
        (this.weight * this.weightCoeffs[this.chainType]) /
        (this.length * this.lengthCoeffs[this.chainType])
      )
    },
    rigelDiameter: function () {
      return this.wireDiameter * this.wireDiameterCoeffs[this.chainType]
    },
    width: function () {
      return this.rigelDiameter * this.rigelDiameterCoeffs[this.chainType]
    }
  },
  filters: {
    numberFormat (x) {
      return Number.isFinite(x) ? x.toFixed(2) : ''
    }
  },
  metaInfo () {
    return {
      title: 'Калькулятор цепей',
      meta: utils.getDefaultMetaTags({
        description:
          'Калькулятор для расчета ширины цепи по ее весу и длине',
        path: this.$router.resolve(this.$route).href,
        title: 'Калькулятор цепей'
      })
    }
  },
  mounted () {
    if (window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  }
}
</script>

<style scoped lang="scss">
  .calculator-page {
    @include page-block-vertical-padding();
    & > .calculator-header {
      text-align: center;
      margin-bottom: 2em;
      & > h1 {
        @include text-block();
        margin-bottom: 0.5em;
      }
      & > p {
        @include text-block();
        font-family: "Baskerville Italic", $font-stack;
        line-height: normal;
        .wf-baskervilleitalic-n4-active & { font-size: 1.5em; }
      }
    }
    & > .calculator-section {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 2em;

      & > .inline-input-wrapper {
        margin-right: 2em;
        &:last-child {
          margin-right: 0;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }

    select {
      background-color: $content-background-color;
      border: 1px solid $default-text-color;
      color: $default-text-color;
      padding: 0.33em;
      min-width: 120px;
      cursor: pointer;
    }

    label {
      display: block;
      text-align: left;
      text-transform: uppercase;
      font-family: "Gotham Pro Regular", $font-stack;
      color: $default-heading-color;
      padding-bottom: 0.5em;

      &::after { text-transform: lowercase; }
      &.gr::after { content: " (гр)"; }
      &.cm::after { content: " (см)"; }
    }
    input[type=number] {
      background-color: $content-background-color;
      box-sizing: border-box;
      border: 1px solid $default-text-color;
      border-radius: 3px;
      color: $default-text-color;
      padding: 0.33em 0.5em;
      text-align: center;
      width: 4em;
      -moz-appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    table {
      border-spacing: 0;
      border-collapse: collapse;
      tr:last-child {
        background-color: #222;
        font-weight: bold;
        color: $default-heading-color;
      }
      td {
        border: 1px solid $default-heading-color;
        padding: 0.5em 1em;
        &:first-child {
          font-family: "Gotham Pro Regular", $font-stack;
          color: $default-heading-color;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ChainsCalculatorPage.vue